var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasModule.quiz)?_c('ChallengingQuestions'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }